<template>

  <div>
    <duty-type-list-add-new
      :is-add-new-duty-type-sidebar-active.sync="isAddNewDutyTypeSidebarActive"
      :duty-type-id="currentyDutyTypeId"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row align-h="end">

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Exibir</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
                debounce="500"
              />
              <b-button
                v-if="$can('manage', 'DutyType')"
                variant="primary"
                @click="addDutyType()"
              >
                <span class="text-nowrap">
                  Nova classificação de plantão
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refDutyTypeListTable"
        class="position-relative"
        :items="fetchDutyTypes"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: dutyType -->
        <template #cell(dutyType)="data">
          <b-media vertical-align="center">
            {{ data.item.type }}
          </b-media>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveDutyTypeStatusVariant(data.item.active)}`"
            class="text-capitalize"
          >
            {{ data.item.active ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              :disabled="!$can('manage', 'DutyType')"
              @click="editDutyType(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalDutyTypes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia,
  BBadge, BPagination, BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import vSelect from 'vue-select'
import { onUnmounted, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useDutyTypeList from './useDutyTypeList'
import dutyTypeStoreModule from '../dutyTypeStoreModule'
import DutyTypeListAddNew from './DutyTypeListAddNew.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,

    DutyTypeListAddNew,
    vSelect,
  },
  directives: {
    Ripple,
  },
  setup() {
    const DUTY_TYPE_APP_STORE_MODULE_NAME = 'app-duty-type'

    // Register module
    if (!store.hasModule(DUTY_TYPE_APP_STORE_MODULE_NAME)) store.registerModule(DUTY_TYPE_APP_STORE_MODULE_NAME, dutyTypeStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DUTY_TYPE_APP_STORE_MODULE_NAME)) store.unregisterModule(DUTY_TYPE_APP_STORE_MODULE_NAME)
    })

    const isAddNewDutyTypeSidebarActive = ref(false)
    const currentyDutyTypeId = ref(null)

    const statusOptions = [
      { label: 'Ativo', value: true },
      { label: 'Inativo', value: false },
    ]

    function addDutyType() {
      currentyDutyTypeId.value = undefined
      isAddNewDutyTypeSidebarActive.value = true
    }

    function editDutyType(dutyType) {
      currentyDutyTypeId.value = dutyType.id
      isAddNewDutyTypeSidebarActive.value = true
    }

    const {
      fetchDutyTypes,
      tableColumns,
      perPage,
      currentPage,
      totalDutyTypes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDutyTypeListTable,
      refetchData,

      // UI
      resolveDutyTypeStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      situationFilter,
      statusFilter,
    } = useDutyTypeList()

    return {

      isAddNewDutyTypeSidebarActive,

      fetchDutyTypes,
      tableColumns,
      perPage,
      currentPage,
      totalDutyTypes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDutyTypeListTable,
      refetchData,
      addDutyType,
      editDutyType,

      // Filter
      avatarText,

      // UI
      resolveDutyTypeStatusVariant,

      currentyDutyTypeId,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      situationFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
